module.exports = __webpack_public_path__ + "media/images/amphibians-3dd2cf9240a6c8b6a1100ed788db2363.jpeg";